import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=f59013ba"
var script = {}
import style0 from "./customerService.vue?vue&type=style&index=0&id=f59013ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports